import React, { useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useWindowSize } from 'react-use';

import CompanyDetailsCard from '../Cards/CompanyDetailsCard';
import ParallaxGrid from '../../molecules/ParallaxGrid';
import SocialShare from '../../molecules/SocialShare';
import StructuredText from './components/StructuredText';
import SubscriptionCard from '../Cards/SubscriptionCard';
import TableOfContents from '../TableOfContents';
import InlineBanner from '../InlineBanner';

import { breakpointNumbers } from '../../atoms/breakpoints';
import {
  Section,
  Wrapper,
  Container,
  RichText,
  Sidebar,
} from './styles/PillarEmbed';

const PillarEmbed = ({
  component,
  showParallaxGrid,
  theme = 'blue',
  showSocials = true,
}) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState(null);
  const { width } = useWindowSize();
  const { xl } = breakpointNumbers;
  const hasSidebarContent =
    (width > xl && component?.companyDetails) ||
    component?.showSubscriptionCard ||
    (component?.showInlineBanner && component?.inlineBanner) ||
    (width >= xl &&
      component?.showTableOfContents &&
      (tableData || component?.tableData));

  return (
    <Section>
      {showParallaxGrid && <ParallaxGrid theme="light" />}
      <Wrapper data-has-sidebar-content={hasSidebarContent}>
        <Container>
          {showSocials && (
            <SocialShare
              orientation={width >= xl ? 'vertical' : 'horizontal'}
              heading={`${t('SHARE ARTICLE')}`}
            />
          )}
          {width < xl && component?.companyDetails && (
            <CompanyDetailsCard {...component?.companyDetails} />
          )}
          {width < xl && component?.showTableOfContents && (
            <TableOfContents
              component={tableData || component?.tableData}
              theme={theme}
            />
          )}
        </Container>
        {component?.structuredText && (
          <StructuredText
            component={component?.structuredText}
            contactInfo={component?.contactInfo}
            setTableData={setTableData}
          />
        )}
        {component?.richText && (
          <RichText
            ref={component?.richTextRef}
            dangerouslySetInnerHTML={{ __html: component?.richText }}
          />
        )}
        {hasSidebarContent && (
          <Sidebar>
            {width > xl && component?.companyDetails && (
              <CompanyDetailsCard {...component?.companyDetails} />
            )}
            {component?.showSubscriptionCard && (
              <SubscriptionCard theme={theme} />
            )}
            {component?.showInlineBanner && component?.inlineBanner && (
              <InlineBanner {...component?.inlineBanner} />
            )}
            {width >= xl && component?.showTableOfContents && (
              <TableOfContents
                component={tableData || component?.tableData}
                theme={theme}
              />
            )}
          </Sidebar>
        )}
      </Wrapper>
    </Section>
  );
};

export default PillarEmbed;
